// extracted by mini-css-extract-plugin
export default {"InviteLink":"InviteLink_InviteLink__HHGMn","InviteLink__link":"InviteLink_InviteLink__link__eS9ed"};